/**
 * Parser das expressões condicionais do Creator.
 *
 * As comparações em si continuam sendo responsabilidade de quem chama, através
 * do callback `evaluateLeaf`. Este módulo só cuida de descobrir onde cada folha
 * começa e termina.
 */
var AND_KEYWORD = "and";
var OR_KEYWORD = "or";
var isWordCharacter = function (char) {
    return char !== undefined && /[\w{}[\].]/.test(char);
};
var matchesKeywordAt = function (expression, index, keyword) {
    var candidate = expression.slice(index, index + keyword.length);
    if (candidate.toLowerCase() !== keyword) {
        return false;
    }
    return (!isWordCharacter(expression[index - 1]) &&
        !isWordCharacter(expression[index + keyword.length]));
};
var skipWhitespace = function (state) {
    while (state.position < state.expression.length) {
        if (!/\s/.test(state.expression[state.position])) {
            return;
        }
        state.position++;
    }
};
var consumeKeyword = function (state, keyword) {
    skipWhitespace(state);
    if (!matchesKeywordAt(state.expression, state.position, keyword)) {
        return false;
    }
    state.position += keyword.length;
    return true;
};
var readLeaf = function (state) {
    var expression = state.expression;
    var start = state.position;
    var quote = null;
    var bracketDepth = 0;
    var parenDepth = 0;
    while (state.position < expression.length) {
        var char = expression[state.position];
        if (quote) {
            if (char === quote) {
                quote = null;
            }
            state.position++;
            continue;
        }
        if (char === "'" || char === '"') {
            quote = char;
            state.position++;
            continue;
        }
        if (char === "[") {
            bracketDepth++;
            state.position++;
            continue;
        }
        if (char === "]") {
            bracketDepth = Math.max(0, bracketDepth - 1);
            state.position++;
            continue;
        }
        if (bracketDepth > 0) {
            state.position++;
            continue;
        }
        if (char === "(") {
            parenDepth++;
            state.position++;
            continue;
        }
        if (char === ")") {
            if (parenDepth === 0) {
                break;
            }
            parenDepth--;
            state.position++;
            continue;
        }
        if (matchesKeywordAt(expression, state.position, AND_KEYWORD) ||
            matchesKeywordAt(expression, state.position, OR_KEYWORD)) {
            break;
        }
        state.position++;
    }
    return expression.slice(start, state.position).trim();
};
var parsePrimary = function (state, evaluateLeaf) {
    skipWhitespace(state);
    if (state.expression[state.position] === "(") {
        state.position++;
        var value = parseOr(state, evaluateLeaf);
        skipWhitespace(state);
        // O `)` é opcional na gramática do SurveyJS; expressão truncada não quebra.
        if (state.expression[state.position] === ")") {
            state.position++;
        }
        return value;
    }
    var leaf = readLeaf(state);
    return leaf ? evaluateLeaf(leaf) : false;
};
var parseAnd = function (state, evaluateLeaf) {
    var value = parsePrimary(state, evaluateLeaf);
    while (consumeKeyword(state, AND_KEYWORD)) {
        var right = parsePrimary(state, evaluateLeaf);
        value = value && right;
    }
    return value;
};
var parseOr = function (state, evaluateLeaf) {
    var value = parseAnd(state, evaluateLeaf);
    while (consumeKeyword(state, OR_KEYWORD)) {
        var right = parseAnd(state, evaluateLeaf);
        value = value || right;
    }
    return value;
};
export var evaluateLogicalExpression = function (expression, evaluateLeaf) {
    if (!expression || !expression.trim()) {
        return false;
    }
    var state = { expression: expression, position: 0 };
    var result = parseOr(state, evaluateLeaf);
    return result;
};
